import React from "react";
import "./NotificationCloseButton.scss";

const NotificationCloseButton = ({ children, onClick }) => (
  <div className="notification-close-button" onClick={onClick}>
    {children}
  </div>
);

export default NotificationCloseButton;
